export const generalKey = 'product_sp_400w_solar_panel';
export const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'ph']; //白名单
export const productPageUrl = 'trail-series';
export const tabsValues = ['Product', 'Bundles', 'Specs', 'Support'];
export const productPageTheme = 'white'; //主题色

// specs&support共用generalKey
export const generalKeys = [
    {
        key: 'product_ps_trail_pr528',
    },
    {
        key: 'product_ps_trail_pr527_p',
    },
    {
        key: 'product_ps_trail_pr526_p',
    },
];
